module.exports = __webpack_public_path__ + "img/Add_Plus_Circle.0b80d416.svg";